exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".aao-condition-confirm{display:flex;align-items:center;justify-content:center}\n", ""]);

// exports
